@if (liveTraining) {
<div [class.locked]="!!isLocked" class="card">
  @if (!!isLocked) {
  <div class="lock">
    <div class="lock-icon">
      @switch (getLockReason()) { @case ('done') {
      <mat-icon svgIcon="check_nobg_v2"></mat-icon>
      } @case ('undecided') {
      <mat-icon svgIcon="lock-filled_v2"></mat-icon>
      } }
    </div>
    <span class="mt-3 mt-md-2 mx-3 mx-md-2 tooltip">{{getLockReasonTooltip()}}</span>
  </div>
  }
  <div class="lts-info-icons">
    <div>
      @if (liveTraining.appointment_type) {
      <div>
        @switch (liveTraining.appointment_type) { @case ('presence') {
        <span class="lts-badge blue" translate>LTS.APPOINTMENT.PRESENCE</span>
        } @case ('virtual') {
        <span class="lts-badge red" translate>LTS.APPOINTMENT.VIRTUAL</span>
        } }
      </div>
      }
    </div>
    @if (liveTraining.session_type) {
    <div class="lts-icon">
      @switch (liveTraining.session_type) { @case ('community_session') {
      <mat-icon svgIcon="peer_session_v2"></mat-icon>
      } @case ('peer_session') {
      <mat-icon svgIcon="community_session_v2"></mat-icon>
      } @default {
      <mat-icon svgIcon="sparring_session_v2"></mat-icon>
      } }
    </div>
    }
  </div>

  @if (liveTraining.name) {
  <div class="lts-header">
    <div class="title-time">
      <span class="title"> {{liveTraining.name}} </span>
      <div class="time">
        <mat-icon svgIcon="clock_v2" class="me-2"></mat-icon>
        <div class="date">
          <span class="day">{{getDay()}} </span>
          <span class="month">{{getMonth()}}</span>
        </div>
        <span translate [translateParams]="{from: getStartTime(), to: getEndTime()}">LTS.TIME</span>
      </div>
    </div>
  </div>
  }
  <div class="lts-info d-flex">
    @if (liveTraining.session_type !== 'community_session' && liveTraining.session_type !== 'peer_session') {
    <div class="trainer subtitle d-flex flex-column mb-3">
      <div class="trainer-gender">
        <mat-icon svgIcon="trainer_v2"></mat-icon>
        @switch (liveTraining.trainer_gender) { @case ('m') {
        <span translate>LTS.WITH_TRAINER.MALE</span>
        } @case ('f') {
        <span translate>LTS.WITH_TRAINER.FEMALE</span>
        } @default {
        <!-- In unspecified case (wanted, wrong data, ...), print a generic headline -->
        <span translate>LTS.WITH_TRAINER.UNDEFINED</span>
        } }
      </div>
      @if (liveTraining.trainer_name) {
      <span class="name">{{liveTraining.trainer_name}}</span>
      } @if (!liveTraining.trainer_name) {
      <span class="name">---</span>
      }
    </div>
    } @else {
    <div class="trainer subtitle d-flex flex-column">
      <span translate>LTS.SELF_ORGANIZED</span>
    </div>
    } @if (liveTraining.appointment_type !== null && liveTraining.appointment_type !== 'virtual') {
    <div class="loc">
      <mat-icon class="me-1" svgIcon="map-pin_v2"></mat-icon>
      @if (liveTraining.location) {
      <ng-container> {{liveTraining.location}}</ng-container>
      }
    </div>
    } @if (!!liveTraining.ics_file) {
    <div class="reserve mt-2">
      <mat-icon class="me-2" svgIcon="calendar_v2"></mat-icon>
      <a class="textbutton" [href]="getIcsFile() | trustUrl">
        <span translate>LTS.RESERVE</span>
      </a>
    </div>
    } @if (liveTraining.logo_url) {
    <div class="coop mt-2">
      <p translate>LTS.COOPERATION_WITH</p>
      <img [src]="liveTraining.logo_url" />
    </div>
    } @if (liveTraining.url) {
    <div class="action">
      <a
        mat-raised-button
        color="primary"
        class="mt-3"
        [class.disabled]="!liveTraining.url"
        [disabled]="!liveTraining.url"
        [href]="liveTraining.url"
        target="_blank"
        rel="noopener noreferrer">
        <span translate>LTS.LINK</span>
      </a>
    </div>
    }
  </div>
</div>
}
